import axios from './index';

class GlobalLockersApi {
  static List = (data) => {
    let query = '?';
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.customerId) {
      query += `user_id=${data.customerId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.selectedStatusTypeValue) {
      query += `status_type=${data.selectedStatusTypeValue}&`;
    }
    if (data.selectedOrderTypeValue) {
      query += `locker_type=${data.selectedLockerTypeValue}&`;
    }
    if (data.filterStartDate) {
      query += `start_date=${data.filterStartDate}&`;
    }
    if (data.filterEndDate) {
      query += `end_date=${data.filterEndDate}&`;
    }
    if (data.is_active == true || data.is_active == false) {
      query += `is_active=${data.is_active}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}${query}`);
  };
}

let base = 'customer/admin/locker-transactions';

export default GlobalLockersApi;
